import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from "chart.js";
import { useEffect, useState } from "react";
import { Loading } from "../../../componentes/loading/loading";
import FortesFinanceiroService from "../../../services/resource/fortesFinanceiroService";
import BarFornecedores from "./BarForncedores";
import DoughnutContasContabil from "./DoughnutContasContabil";
import PieCentrosCusto from "./PieCentrosCusto";
import LineTotalPorDia from "./LineTotalPorDia";

// Registrar os módulos do Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function ContasPagarDashboard({ dataInicial, dataFinal, codigoEmpresa, filtrar, setLoad }) {
    const [relatorio, setRelatorio] = useState(null);
    const [loading, setLoading] = useState(false);
    const service = new FortesFinanceiroService();

    useEffect(() => {
        listarRelatorios()
    }, [filtrar]);

      useEffect(() => {
        document.title = "MyDash | Prestação de Contas"
    }, [])

    const listarRelatorios = () => {
        setLoading(true);
        setLoad(true);
        service.relatorios({
            dataInicial: dataInicial,
            dataFinal: dataFinal,
            codigoEmpresa: codigoEmpresa
        }).then(response => {
            setRelatorio(response.data);
        }).finally(() => {
            setLoading(false);
            setLoad(false);
        });
    }

    return (
        <>
            {relatorio !== null && !loading ?
                <>
                    <div id="metricas" className="grid grid-cols-1 lg:grid-cols-1 gap-1 mb-6">
                        <BarFornecedores data={relatorio} />
                    </div>

                    <div id="metricas" className="grid grid-cols-1 lg:grid-cols-2 gap-1 mb-6">
                        <PieCentrosCusto data={relatorio} />
                        <DoughnutContasContabil data={relatorio} />
                    </div>
                    <div id="metricas" className="grid grid-cols-1 lg:grid-cols-1 gap-1 mb-6">
                        <LineTotalPorDia data={relatorio} />
                      
                    </div>
                </>
                :
                <div className="h-96">
                    <Loading label="Carregando Dashboard..." />
                </div>
            }
        </>
    )
}

export default ContasPagarDashboard;